import { render, staticRenderFns } from "./StorageLocations.vue?vue&type=template&id=1253c058&"
import script from "./StorageLocations.vue?vue&type=script&lang=js&"
export * from "./StorageLocations.vue?vue&type=script&lang=js&"
import style0 from "./StorageLocations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports